// https://codepen.io/Prachl/pen/jjKzEy

import {getCoords} from '../../common/js/util.js';


window.App = window.App || {
    W: $(window)
};


function render() {
    const SELECTOR = {
        ANIMATION: 'animation',
        ANIMATED: 'animated',
        BOUND: 'data-animation-bound',
    };


    // Констатны зависящие от размеров экрана
    let VIEWPORT_HEIGHT;

    setConstants();
    App.W.on('resized', setConstants);

    function setConstants() {
        VIEWPORT_HEIGHT = document.documentElement.clientHeight;
    }


    // кешируем элементы которые нужно анимировать
    let ANIMATIONS;

    // пересчет если подгрузился контент
    const resizeObserver = new ResizeObserver(countElements);
    resizeObserver.observe(document.documentElement);

    App.W.on('resized slide:ready', countElements);
    App.W.one('scroll', countElements);

    function countElements() {
        ANIMATIONS = Array.from(document.querySelectorAll(`.${SELECTOR.ANIMATION}:not(.${SELECTOR.ANIMATED})`))
            .map(elementDom => {
                return {
                    dom: elementDom,
                    top: getCoords(elementDom).top,
                    bound: elementDom.getAttribute(SELECTOR.BOUND) || 0.03
                };
            });
    }
    countElements();


    // Анимация по доскролу
    App.W.on('scroll slide:change', animateElements);

    function animateElements() {
        let deletionOffset = 0;

        ANIMATIONS.slice().forEach((animation, i) => {
            if (animation.top < window.pageYOffset + VIEWPORT_HEIGHT * (1 - animation.bound)) {
                ANIMATIONS.splice(i - deletionOffset++, 1);
                animation.dom.classList.add(SELECTOR.ANIMATED);
            } else {
                animation.dom.classList.remove(SELECTOR.ANIMATED);
            }
        });
    }
    animateElements();
}


if (document.querySelectorAll('.animation').length) render();



// WEBPACK FOOTER //
// ./_src/components/scrollAnimation/index.js